import { useRouter } from 'next/router';
import { useContext, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import { createRippleEffectRelative } from '../../../Utils/helper';
import { addTocartBogoHandler } from '../../../Utils/productAction';
import { useIsDesktop } from '../../../Utils/productPageUtils';
import {
  customStyles,
  HealthCenterStylePopup,
} from '../../../Utils/redirections';
import { removeRoute } from '../../Clinic/common';
import { ModalCrossbtn } from '../../ProductNew/TrustStrip/styled';
import CarouselSection from '../../StoreHomePage/BogoClothDiaper/CarouselSection';
import { getProductIds } from '../../StoreHomePage/BogoClothDiaper/common';
import {
  fireAddProductEvent,
  firePopupEvent,
} from '../../StoreHomePage/BogoClothDiaper/instrumentation';
import MoreVariantsCard from './MoreVariantsCard.jsx';
import { SelectDiaperButton } from './MoreVariantsCard.jsx/styled';
import CardContext from '../../StoreHomePage/ProductCard/ProductCardContext';
import { updateVariantType } from '../DiaperNewVersionMain/constant';

export default function BogoProductListingPopup(props) {
  const contextData = useContext(CardContext);
  const {
    offerCartData,
    setOfferCartData,
    setShowImagesPopup,
    productData,
    popupImages,
    setPopupImages,
    hideStickyStrip,
  } = contextData;
  const productId = productData?.id || productData?._id;
  const router = useRouter();
  const selectDiaperbtn = useRef();
  const [variantProductId, setVariantProductId] = useState(productId);
  const mainProductImages = hideStickyStrip
    ? popupImages?.mainProductImages
    : offerCartData?.mainProductImages;
  const otherProductImages = hideStickyStrip
    ? popupImages?.productList
    : offerCartData?.productList;

  updateVariantType(offerCartData);

  const CenterPopup = HealthCenterStylePopup('50%', 'auto', 'auto', '50%');
  const BottomStylePopup = customStyles('', '', '0', '');
  const isDesktop = useIsDesktop();

  const onClose = () => {
    setShowImagesPopup(false);
    removeRoute('bogoPopup', router);
    firePopupEvent(
      productData,
      'discard_popup',
      offerCartData?.offerData?.offerCode,
    );
  };
  useEffect(() => {
    document.body.classList.add('noScroll');
    firePopupEvent(
      productData,
      'viewed_popup',
      offerCartData?.offerData?.offerCode,
    );
    return () => {
      document.body.classList.remove('noScroll');
    };
  }, []);

  const onClickHandler = async () => {
    fireAddProductEvent(
      productData,
      variantProductId,
      offerCartData?.offerData?.offerCode,
      true,
    );
    const productIdString = Number.isInteger(variantProductId)
      ? JSON.stringify(variantProductId)
      : variantProductId;
    const params = {
      productId: productIdString,
      ids: getProductIds(otherProductImages),
      add: false,
      less: false,
      addToCart: true,
      isFirstTime: false,
      selectProduct: false,
      selectedProductId: productIdString,
    };
    const diaperOfferData = await addTocartBogoHandler(params);
    if (!hideStickyStrip) setOfferCartData(diaperOfferData?.data);
    else setPopupImages(diaperOfferData?.data);
    onClose();
  };
  const handleBackClick = (url) => {
    if (!url.includes('bogoPopup')) {
      setShowImagesPopup(false);
    }
  };
  useRouterChangeStart(handleBackClick);
  return (
    <>
      <Modal
        isOpen={true}
        style={isDesktop ? CenterPopup : BottomStylePopup}
        onRequestClose={onClose}
        bodyOpenClassName={'noScroll'}
        htmlOpenClassName={'noScroll'}
      >
        <ModalCrossbtn
          src="/images/close_black.svg"
          alt="trust popup close"
          onClick={onClose}
          bogoPopup
        />
        <section>
          <CarouselSection
            mainProductImages={mainProductImages}
            otherProductImages={otherProductImages}
            selectedCard={variantProductId}
          />
          <MoreVariantsCard
            otherProductImages={otherProductImages}
            setOfferCartData={setOfferCartData}
            productId={productId}
            setVariantProductId={setVariantProductId}
            variantProductId={variantProductId}
            hideStickyStrip={hideStickyStrip}
            setPopupImages={setPopupImages}
          />
          <SelectDiaperButton
            ref={selectDiaperbtn}
            // onClick={onClickHandler}
            onClick={(event) => {
              createRippleEffectRelative(event, selectDiaperbtn.current);
              onClickHandler();
            }}
          >
            Select this diaper
          </SelectDiaperButton>
        </section>
      </Modal>
    </>
  );
}
